<button
  class="btn btn-neutral"
  (click)="exportSavefile()"
  appAnalyticsClick="Savefile:Export"
  appSfx="ui-click"
  [sfxTrigger]="['click', 'hover']"
>
  Export
</button>
